// extracted by mini-css-extract-plugin
export default {"SlideContainer":"styles_SlideContainer__iAK6D","SlideImage":"styles_SlideImage__S8NdQ","SlideWrapper":"styles_SlideWrapper__rUDzY"};